import Vuex from 'vuex';
import Vue from 'vue';
import common from './common/common';
import config from '../others/interface';
// 惰性注册  为什么?  因为只对单个页面进行管理,别的页面基本上用不上,可以对store进行拆分,,这样
// 优点 减小store的负担,减少app主js的大小,优化页面,要用的时候注册添加,,用完就删除
Vue.use(Vuex);

export function createStore () {
  return new Vuex.Store({
    modules: {

    },
    state: {
      config,
      ...common.state,
    },
    actions: {
      ...common.actions,
    },
    mutations: {
      ...common.mutations,

    },
  });
}



// WEBPACK FOOTER //
// ./src/store/index.js